export default __webpack_public_path__ + "static/media/banner-cartoes-categoria.145c2c44.svg";